<div class="ai-advice-widget" (click)="openAiAdviceModal()">
    <div class="ai-advice-widget__header">
        <div class="ai-advice-widget__header-content">
            <div class="ai-advice-widget__title">{{ title }}</div>

            <ng-container *ngIf="isEditMode">
                <div (click)="toggleSizeDropdown(index, $event)" cdkOverlayOrigin #editTrigger="cdkOverlayOrigin"
                    class="ai-advice-widget__icon-container">
                    <div class="ai-advice-widget__icon">
                        <img src="assets/icons/widget/pencil.svg" alt="AI Advice Widget">
                    </div>
                </div>
                <!-- Size Dropdown -->
                <app-widget-edit [editTrigger]="editTrigger" [index]="index" [activeDropdownIndex]="activeDropdownIndex"
                    [getAvailableSizes]="getAvailableSizes" [changeWidgetSize]="changeWidgetSize"
                    [removeWidget]="removeWidget" [toggleSizeDropdown]="toggleSizeDropdown">
                </app-widget-edit>
            </ng-container>
            <ng-container *ngIf="isAddMode">
                <img class="add-widget-btn-icon no-dark-filter" src="assets/icons/img_frame-1171275385.png"
                    alt="Settings" (click)="addWidget.emit(); $event.stopPropagation()" />
            </ng-container>
        </div>
    </div>
    <div class="ai-advice-widget__body">
        <div class="ai-advice-widget__content">
            <div class="ai-advice-widget__avatar-section">
                <img src="assets/icons/widget/star-06.svg" alt="AI Advice Widget">
                <div class="ai-advice-widget__avatar-info">
                    <div class="ai-advice-widget__avatar-name">{{ aiName }}</div>
                </div>
            </div>
            <div class="ai-advice-widget__message-section">
                <div class="ai-advice-widget__message">{{ message }}</div>
            </div>
        </div>
        <div class="ai-advice-widget__saving-section">
            <div class="ai-advice-widget__saving-label">Saving</div>
            <div class="ai-advice-widget__saving-amount">{{ savingAmount }}</div>
        </div>
    </div>
</div>